module.exports = __webpack_public_path__ + "img/ultralow.305a06b0.png";